<template>
	<app-section @click="$emit('click', propValue)" class="tight mr-4">
		<div class="flex justify-between relative items-center gap-3">
			<p class="text-13 font-secondary" v-html="title" />
			<p v-if="price" class="font-semibold">{{ $filters.formatCurrency(text) }}</p>
			<p v-else class="font-semibold">{{ text }}</p>
		</div>
		<div v-if="comparison">
			<p class="text-13" :class="comparison > 0 ? 'text-success' : 'text-primary'" v-if="comparison">
				<app-icon
					:icon="comparison > 0 ? 'sort-up' : 'sort-down'"
					:class="comparison > 0 ? 'text-success' : 'text-primary'"
				/>
				{{ comparison }}%
			</p>
			<p v-else></p>
		</div>
		<div v-if="propValue === 'CREDIT_CARD' && creditCardData" class="flex flex-col">
			<app-line space="1" />
			<app-icon icon="credit-card" class="text-secondary" />
			<div class="flex justify-between w-full">
				<span class="text-13">
					{{ $t('totalValue') }}
				</span>
				<span class="text-13 font-semibold ml-2">{{ $filters.formatCurrency(creditCardData.totalValue) }}</span>
			</div>
		</div>
	</app-section>
</template>

<script>
	import AppLine from '@/components/app/AppLine.vue';

	export default {
		name: 'AppCard',
		components: { AppLine },
		emits: ['click'],
		props: {
			icon: {
				required: false,
				type: String,
			},
			section: {
				required: false,
				type: Boolean,
				default: true,
			},
			title: {
				required: true,
				type: String,
			},
			text: {
				required: false,
				type: [String, Number],
			},
			creditCardData: {
				type: Object,
				required: false,
			},
			price: {
				type: Boolean,
				default: false,
			},
			propValue: {
				required: true,
			},
			comparison: {
				required: false,
				type: [String, Number],
			},
		},
	};
</script>
